module.exports = __webpack_public_path__ + "static/img/manual-16.7310805.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-16.png
// module id = Itug
// module chunks = 4